import { getApiBaseUrl as S, api as c } from "../utils/configuration.js";
import { removeItemInLocalStorageAndSendEvent as R, isSDK as w, setItemInLocalStorageAndSendEvent as u } from "../utils/utils.js";
import l from "axios";
import T from "lodash/memoize";
import v from "query-string";
import { reactRouterV7BrowserTracingIntegration as _, wrapCreateBrowserRouterV7 as A, init as O, withScope as k, captureException as L } from "@sentry/react";
import { useEffect as j } from "react";
import { matchRoutes as C, createRoutesFromChildren as N, useNavigationType as U, useLocation as x } from "react-router";
import { createBrowserRouter as I } from "react-router-dom";
let o, p = new Promise((e) => {
  o = e;
});
const b = {
  init: () => {
    const e = fetch(`${S()}/environment.json`).then((t) => t.json()).catch((t) => (d(t, { displayToast: !1 }), {
      environment: "",
      authClientUrl: ""
    }));
    p = e, o && (o(e), o = void 0);
  },
  getEnvironment: async () => (await p).environment
}, B = {
  dsn: "https://6a894064a4b545e49f19097b1a89b842@o372675.ingest.us.sentry.io/5896667",
  integrations: [
    _({
      useEffect: j,
      useLocation: x,
      useNavigationType: U,
      createRoutesFromChildren: N,
      matchRoutes: C
    })
  ],
  tracesSampleRate: 1
}, M = (...e) => k((t) => (t.setExtra("propifyFlag", !0), L(...e))), z = A(I), P = {
  init: (e = {}) => {
    const t = process.env.NODE_ENV === "production", s = process.env.RELEASE_NAME;
    t && s && b.getEnvironment().then((r) => {
      (r === "stage" || r === "production") && O({
        ...B,
        ...e,
        environment: r,
        release: s
      });
    });
  },
  trackError: M,
  sentryCreateBrowserRouter: z
}, G = "logout_channel", J = "logout_event", $ = new BroadcastChannel(G), V = () => {
  $.postMessage(J);
}, pe = (e) => u("id_token", e), g = () => localStorage.getItem("id_token"), m = () => localStorage.getItem("organization_token"), ue = (e) => u("organization_token", e), q = T((e) => {
  if (!e)
    return null;
  const s = e.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"), r = decodeURIComponent(
    atob(s).split("").map((i) => `%${`00${i.charCodeAt(0).toString(16)}`.slice(-2)}`).join("")
  );
  return JSON.parse(r);
}), F = 5e3, f = (e) => {
  const t = q(e);
  return t ? e && Date.now() < t.exp * 1e3 - F : !1;
}, H = () => {
  const e = g();
  return !!e && !!f(e);
}, W = () => w() && !!m(), h = () => {
  V(), R("id_token");
}, D = (e, t) => {
  if (!e)
    return t || "";
  const s = e.displayMessage || e.textResponse || e.message;
  return t ? s || t : s || "";
}, d = (e, {
  displayToast: t = !0,
  toastMessage: s,
  toastFallbackMessage: r = "Unexpected Error",
  rethrowError: i,
  sendToSentry: E = !0,
  toastHandler: a
}) => {
  if (t && a) {
    const y = s ?? D(e, r);
    a.error(y);
  }
  if (E && P.trackError(JSON.stringify(e)), i)
    throw e;
}, K = (e, t) => e && e.length && t && t.indexOf("application/json") !== -1 ? JSON.parse(e) : e && e.length ? e : "", le = async (e) => {
  const t = await e.text(), s = e.headers.get("content-type");
  return K(t, s);
}, n = l.create({
  baseURL: "/rest",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json"
  },
  paramsSerializer: (e) => v.stringify(e)
});
class X extends Error {
  response;
  jsonResponse;
  textResponse;
  displayMessage;
  status;
  constructor(t, s) {
    super(t), this.response = s, this.jsonResponse = {}, this.textResponse = "", this.displayMessage = t;
  }
}
const Y = (e) => {
  if (!(!e || typeof e != "object")) {
    if (typeof e.message == "string" && e.message.trim())
      return e.message;
    if (typeof e.detail == "string" && e.detail.trim())
      return e.detail;
    if (typeof e.title == "string" && e.title.trim())
      return e.title;
    if (Array.isArray(e.errors) && e.errors.length > 0) {
      const [t] = e.errors;
      if (typeof t == "string" && t.trim())
        return t;
    }
    if (typeof e.errors == "string" && e.errors.trim())
      return e.errors;
  }
};
n.interceptors.request.use((e) => {
  if (e.headers = e.headers ?? {}, H()) {
    if (!e.url.startsWith("/") && (!c.BASE_URL || !e.url.startsWith(c.BASE_URL)))
      return e;
    const t = g();
    if (!f(t))
      return h(), Promise.reject(new l.Cancel("The access token is missing or expired"));
    e.headers.Authorization = e.headers.Authorization || `Bearer ${t}`;
  } else W() && (e.headers.Token = m());
  return e;
});
n.interceptors.response.use(
  (e) => e,
  (e) => {
    let t = `Unhandled status: ${e.response?.status}`;
    e.response?.status === 401 && (h(), t = "The username or password you entered is incorrect."), e.response?.status === 500 && (t = "Internal Server Error"), e.response?.status === 400 && (t = "Bad Request"), e.response?.status === 504 && (t = "Gateway timeout");
    const s = new X(t, e.response);
    if (s.status = e.response?.status, e.response?.data instanceof Object) {
      s.jsonResponse = e.response.data;
      const r = Y(s.jsonResponse);
      r && (s.displayMessage = r);
    } else
      s.textResponse = e.response?.data;
    throw s;
  }
);
const ge = {
  get: (e, t) => n.get(e, t).then((s) => s.data),
  post: (e, t, s) => n.post(t, e, s).then((r) => r.data),
  put: (e, t) => n.put(t, e).then((s) => s.data),
  patch: (e, t) => n.patch(t, e).then((s) => s.data),
  delete: (e) => n.delete(e).then((t) => t.data)
}, Q = (e) => new Promise((t) => setTimeout(t, e)), Z = async (e, t) => {
  try {
    return await e();
  } catch (s) {
    if (d(s, { displayToast: !1 }), t.length > 0 && t[0])
      return await Q(t[0]), Z(e, t.slice(1));
    throw s;
  }
};
export {
  b as EnvironmentService,
  J as LOGOUT_EVENT_NAME,
  G as LOGOUT_MESSAGE_CHANNEL,
  X as ResponseError,
  P as SentryService,
  ge as crudService,
  Q as delay,
  D as getErrorMessage,
  K as getErrorResponse,
  le as getResponseText,
  g as getToken,
  d as handleError,
  W as isLoggedInSdk,
  H as loggedIn,
  h as logout,
  q as parseJwt,
  Z as retryOnFail,
  ue as setOrganizationToken,
  pe as setToken
};
//# sourceMappingURL=request-zRag5cDd.js.map
